// src/config/constants.js
export const BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
